import { ArrowUpRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { Reveal } from "./Reveal";
import { PARTNERS } from "../data/content";

const Partners = ({ dark = false, label = "Partners & Suppliers", title = "Manufacturers we work with." }) => (
  <section data-testid="partners-section" className={`section-pad ${dark ? "bg-coal text-paper" : "bg-paper border-t border-ink/10"}`}>
    <div className="container-ax">
      <SectionHeading dark={dark} number="02" label={label} title={title} />
      <Reveal i={1} className="-mt-6 mb-12 max-w-xl">
        <p className={`text-[15px] leading-relaxed ${dark ? "text-paper/55" : "text-graphite"}`}>
          A selected network of European manufacturers we source from — doors, furniture, ceramics, lighting and wellness equipment for our interior and renovation projects.
        </p>
      </Reveal>
      <div className={`border-b ${dark ? "border-white/10" : "border-ink/10"}`}>
        {PARTNERS.map((p, i) => (
          <Reveal key={p.name} i={i % 4}>
            <a
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`partner-${p.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`group grid grid-cols-12 gap-3 sm:gap-4 items-baseline py-7 sm:py-8 border-t ${dark ? "border-white/10" : "border-ink/10"}`}
            >
              <span className={`col-span-2 sm:col-span-1 label-tech ${dark ? "text-electric" : "text-cobalt"}`}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className={`col-span-10 sm:col-span-3 label-tech ${dark ? "text-paper/50" : "text-graphite"}`}>{p.category}</span>
              <span className={`col-span-10 col-start-3 sm:col-span-4 sm:col-start-5 text-xl sm:text-2xl font-semibold tracking-tight inline-flex items-center gap-2 ${dark ? "text-paper group-hover:text-electric" : "text-coal group-hover:text-cobalt"} transition-colors duration-300`}>
                {p.name}
                <ArrowUpRight size={18} className="opacity-30 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
              </span>
              <span className={`col-span-12 sm:col-span-4 text-sm leading-relaxed ${dark ? "text-paper/55" : "text-graphite"}`}>{p.description}</span>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Partners;
